import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import NotInterestedRoundedIcon from "@mui/icons-material/NotInterestedRounded";
const UnauthorizedPage = () => {
	return (
		<Container maxWidth>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					minHeight: "100vh",
					backgroundColor: "#f5f5f5",
					borderRadius: 2,
					boxShadow: 3,
					textAlign: "center",
					padding: 3,
					minWidth: "100vw",
				}}
			>
				<NotInterestedRoundedIcon
					sx={{ fontSize: 80, color: "error.main", mb: 2 }}
				/>
				<Typography variant="h4" color="textPrimary" sx={{ fontWeight: 600 }}>
					You do not have permission to access this page.
				</Typography>
				<Typography variant="body1" color="textSecondary" sx={{ my: 2 }}>
					Please contact your administrator if you think this is a mistake.
				</Typography>
			</Box>
		</Container>
	);
};

export default UnauthorizedPage;
